import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  container: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
    },
  },
  root: {
    maxWidth: 1000,
    [theme.breakpoints.down('md')]: {
      maxWidth: '100%',
    },
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: theme.spacing(3),
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      gap: theme.spacing(2),
    },
  },
  headerLeft: {},
  titleRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(0.5),
    [theme.breakpoints.down('md')]: {
      gap: theme.spacing(1.5),
    },
  },
  title: {
    fontWeight: 700,
    fontSize: 32,
    color: '#00234B',
    fontFamily: '"Source Serif Pro", serif',
    whiteSpace: 'nowrap',
    [theme.breakpoints.down('md')]: {
      fontSize: 28,
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 26,
      whiteSpace: 'normal',
    },
  },
  subtitle: {
    fontSize: 14,
    color: '#6A6A6A',
  },
  headerButtons: {
    display: 'flex',
    gap: theme.spacing(1.5),
    [theme.breakpoints.down('sm')]: {
      gap: theme.spacing(1),
    },
    [theme.breakpoints.down('xs')]: {
      flexWrap: 'wrap',
      width: '100%',
    },
  },
  cancelButton: {
    color: '#00234B',
    fontWeight: 600,
    fontSize: 13,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
    padding: theme.spacing(1, 2),
    '&:hover': {
      backgroundColor: 'rgba(0, 35, 75, 0.04)',
    },
  },
  saveButton: {
    backgroundColor: '#00234B',
    color: '#FFFFFF',
    fontWeight: 600,
    fontSize: 13,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
    padding: theme.spacing(1, 2.5),
    borderRadius: 4,
    '&:hover': {
      backgroundColor: '#001834',
    },
    '&:disabled': {
      backgroundColor: '#9E9E9E',
      color: '#FFFFFF',
    },
  },
  publishButton: {
    backgroundColor: 'transparent',
    color: '#00234B',
    fontWeight: 600,
    fontSize: 13,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
    padding: theme.spacing(1, 2.5),
    borderRadius: 4,
    border: '2px solid #00234B',
    '&:hover': {
      backgroundColor: 'rgba(0, 35, 75, 0.04)',
    },
    '&:disabled': {
      borderColor: '#9E9E9E',
      color: '#9E9E9E',
    },
  },
  contentContainer: {
    display: 'flex',
    gap: theme.spacing(3),
    [theme.breakpoints.down('md')]: {
      gap: theme.spacing(2),
    },
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  sidebar: {
    minWidth: 180,
    flexShrink: 0,
    [theme.breakpoints.down('md')]: {
      minWidth: 140,
    },
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  sidebarNav: {
    position: 'sticky',
    top: 80,
  },
  sidebarItem: {
    padding: theme.spacing(1, 0),
    cursor: 'pointer',
    fontSize: 13,
    fontWeight: 600,
    color: '#6A6A6A',
    textTransform: 'uppercase',
    letterSpacing: 0.5,
    transition: 'color 0.2s ease',
    '&:hover': {
      color: '#00234B',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: 11,
      letterSpacing: 0.3,
    },
  },
  sidebarItemActive: {
    color: '#00234B',
  },
  mainContent: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    minWidth: 0,
    [theme.breakpoints.down('md')]: {
      gap: theme.spacing(2),
    },
  },
  section: {
    backgroundColor: '#FFFFFF',
    borderRadius: 8,
    border: '1px solid #E0E0E0',
    overflow: 'hidden',
  },
  sectionHeader: {
    padding: theme.spacing(2.5, 3),
    borderBottom: '1px solid #F0F0F0',
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2),
    },
  },
  sectionHeaderIcon: {
    color: '#4CAF50',
    fontSize: 22,
  },
  sectionHeaderContent: {},
  sectionTitle: {
    fontWeight: 600,
    fontSize: 16,
    color: '#00234B',
  },
  sectionSubtitle: {
    fontSize: 13,
    color: '#6A6A6A',
    marginTop: 2,
  },
  sectionContent: {
    padding: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2),
    },
  },
  verifiedGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: theme.spacing(3),
    [theme.breakpoints.down('md')]: {
      gridTemplateColumns: 'repeat(3, 1fr)',
      gap: theme.spacing(2),
    },
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: 'repeat(2, 1fr)',
    },
    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: '1fr',
    },
  },
  fieldGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
  },
  fieldLabel: {
    fontSize: 11,
    fontWeight: 600,
    color: '#6A6A6A',
    textTransform: 'uppercase',
    letterSpacing: 0.5,
  },
  fieldValue: {
    fontSize: 15,
    fontWeight: 500,
    color: '#00234B',
  },
  formGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      gap: theme.spacing(2),
    },
    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: '1fr',
    },
  },
  formGridNameAge: {
    display: 'grid',
    gridTemplateColumns: '2fr 1fr',
    gap: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      gap: theme.spacing(2),
    },
    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: '1fr',
    },
  },
  formGridThree: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      gap: theme.spacing(2),
    },
    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: '1fr',
    },
  },
  formField: {
    marginBottom: 0,
  },
  textField: {
    '& .MuiOutlinedInput-root': {
      backgroundColor: '#FFFFFF',
    },
    '& .MuiInputLabel-outlined': {
      fontSize: 14,
    },
    '& .MuiOutlinedInput-input': {
      fontSize: 14,
      padding: '14px',
    },
  },
  select: {
    '& .MuiOutlinedInput-root': {
      backgroundColor: '#FFFFFF',
    },
    '& .MuiSelect-outlined': {
      fontSize: 14,
      padding: '14px',
    },
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(8),
    minHeight: 400,
  },
  errorContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(8),
    textAlign: 'center',
  },
  errorTitle: {
    fontWeight: 600,
    fontSize: 18,
    color: '#333333',
    marginBottom: theme.spacing(1),
  },
  errorText: {
    fontSize: 14,
    color: '#6A6A6A',
    marginBottom: theme.spacing(2),
  },
  backButton: {
    color: '#3268A7',
    fontWeight: 600,
  },
  privacySection: {
    marginTop: theme.spacing(1),
  },
  privacyLabel: {
    fontWeight: 600,
    fontSize: 14,
    color: '#333333',
    marginBottom: theme.spacing(1),
  },
  privacyDescription: {
    fontSize: 13,
    color: '#6A6A6A',
    marginBottom: theme.spacing(2),
  },
  privacyOptions: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  witnessCard: {
    backgroundColor: '#F9F9F9',
    borderRadius: 4,
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    '&:last-child': {
      marginBottom: 0,
    },
  },
  witnessName: {
    fontWeight: 600,
    fontSize: 14,
    color: '#333333',
  },
  witnessRelationship: {
    fontSize: 13,
    color: '#6A6A6A',
  },
  mediaGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: 'repeat(3, 1fr)',
      gap: theme.spacing(1.5),
    },
    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: 'repeat(2, 1fr)',
    },
  },
  mediaItem: {
    aspectRatio: '1',
    borderRadius: 8,
    overflow: 'hidden',
    backgroundColor: '#F0F0F0',
  },
  mediaImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  emptyMedia: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#9E9E9E',
    fontSize: 14,
    height: 120,
    border: '2px dashed #E0E0E0',
    borderRadius: 8,
  },
  sectionHeaderWithAction: {
    padding: theme.spacing(2.5, 3),
    borderBottom: '1px solid #F0F0F0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2),
      flexWrap: 'wrap',
      gap: theme.spacing(1),
    },
  },
  witnessesGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
      gap: theme.spacing(2),
    },
  },
  witnessFieldWrapper: {
    display: 'flex',
    flexDirection: 'column',
  },
  clearWitnessButton: {
    color: '#9E9E9E',
    padding: theme.spacing(0.5),
    '&:hover': {
      color: '#D32F2F',
      backgroundColor: 'transparent',
    },
  },
  richTextContainer: {
    border: '1px solid #E0E0E0',
    borderRadius: 4,
    overflow: 'hidden',
    marginBottom: theme.spacing(3),
  },
  richTextToolbar: {
    display: 'flex',
    gap: theme.spacing(0.5),
    padding: theme.spacing(1, 1.5),
    borderBottom: '1px solid #E0E0E0',
    backgroundColor: '#FAFAFA',
  },
  toolbarButton: {
    color: '#666666',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
  },
  storyTextField: {
    width: '100%',
    '& .MuiOutlinedInput-root': {
      backgroundColor: '#FFFFFF',
      '& fieldset': {
        border: 'none',
      },
    },
    '& .MuiOutlinedInput-input': {
      fontSize: 14,
      padding: theme.spacing(2),
    },
  },
  noTopBorder: {
    borderTop: 'none !important',
  },
  characterCount: {
    textAlign: 'right',
    padding: theme.spacing(1, 2),
    fontSize: 12,
    color: '#9E9E9E',
    borderTop: '1px solid #E0E0E0',
  },
  photosTitle: {
    fontWeight: 600,
    fontSize: 14,
    color: '#333333',
    marginBottom: theme.spacing(1.5),
  },
  photosGrid: {
    display: 'flex',
    gap: theme.spacing(2),
    flexWrap: 'wrap',
  },
  photoItem: {
    position: 'relative',
    width: 100,
    height: 100,
    borderRadius: 8,
    overflow: 'hidden',
  },
  photoImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  removePhotoButton: {
    position: 'absolute',
    top: 4,
    right: 4,
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 1)',
    },
  },
  addPhotoButton: {
    width: 100,
    height: 100,
    border: '2px dashed #E0E0E0',
    borderRadius: 8,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    transition: 'border-color 0.2s ease',
    '&:hover': {
      borderColor: '#00234B',
    },
  },
  addPhotoIcon: {
    color: '#9E9E9E',
    fontSize: 24,
    marginBottom: theme.spacing(0.5),
  },
  addPhotoText: {
    fontSize: 10,
    fontWeight: 600,
    color: '#6A6A6A',
    textTransform: 'uppercase',
    letterSpacing: 0.5,
  },
  privacyField: {
    marginBottom: theme.spacing(3),
  },
  privacyFieldLabel: {
    fontWeight: 600,
    fontSize: 12,
    color: '#00234B',
    textTransform: 'uppercase',
    letterSpacing: 0.5,
    marginBottom: theme.spacing(1),
  },
  privacyFieldHelper: {
    fontSize: 13,
    color: '#6A6A6A',
    marginTop: theme.spacing(0.5),
  },
  privacyToggleRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    borderTop: '1px solid #F0F0F0',
    borderBottom: '1px solid #F0F0F0',
    marginBottom: theme.spacing(3),
  },
  deleteSection: {
    marginTop: theme.spacing(2),
  },
  deleteTitle: {
    fontWeight: 600,
    fontSize: 14,
    color: '#D32F2F',
    marginBottom: theme.spacing(1.5),
  },
  deleteWarning: {
    backgroundColor: '#FFF5F5',
    border: '1px solid #FFCDD2',
    borderRadius: 4,
    padding: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },
  deleteWarningContent: {
    flex: 1,
  },
  deleteWarningTitle: {
    fontWeight: 600,
    fontSize: 13,
    color: '#D32F2F',
    marginBottom: theme.spacing(0.5),
  },
  deleteWarningText: {
    fontSize: 13,
    color: '#B71C1C',
  },
  deleteButton: {
    color: '#D32F2F',
    borderColor: '#D32F2F',
    border: '1px solid',
    fontWeight: 600,
    fontSize: 12,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
    whiteSpace: 'nowrap',
    '&:hover': {
      backgroundColor: 'rgba(211, 47, 47, 0.04)',
    },
  },
  // Display name preview styles
  displayNamePreview: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginTop: theme.spacing(1),
    padding: theme.spacing(1.5),
    backgroundColor: '#F5F5F5',
    borderRadius: 4,
  },
  displayNamePreviewLabel: {
    fontSize: 13,
    color: '#6A6A6A',
  },
  displayNamePreviewValue: {
    fontSize: 14,
    fontWeight: 600,
    color: '#00234B',
  },
  // Witness display format
  witnessDisplayAs: {
    fontSize: 12,
    color: '#6A6A6A',
    marginTop: theme.spacing(0.5),
    fontStyle: 'italic',
  },
  // Story textarea without rich text
  storyContainer: {
    marginBottom: theme.spacing(3),
  },
  storyTextArea: {
    '& .MuiOutlinedInput-root': {
      backgroundColor: '#FFFFFF',
    },
    '& .MuiOutlinedInput-input': {
      fontSize: 14,
      lineHeight: 1.6,
    },
  },
  characterCountError: {
    color: '#D32F2F !important',
    fontWeight: 600,
  },
  characterLimitReached: {
    color: '#D32F2F',
    fontWeight: 500,
  },
  // Publish dialog styles
  publishDialogTitle: {
    '& .MuiDialogTitle-root, & h2': {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1.5),
    },
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    color: '#00234B',
    fontWeight: 600,
    padding: theme.spacing(2, 3),
  },
  publishDialogIcon: {
    color: '#00234B',
    fontSize: 24,
    flexShrink: 0,
  },
  publishDialogText: {
    fontSize: 14,
    color: '#333333',
    lineHeight: 1.6,
    marginBottom: theme.spacing(2),
  },
  publishDialogInfo: {
    backgroundColor: '#F5F9FF',
    border: '1px solid #90CAF9',
    borderRadius: 4,
    padding: theme.spacing(2),
  },
  publishDialogInfoTitle: {
    fontSize: 13,
    fontWeight: 600,
    color: '#1565C0',
    marginBottom: theme.spacing(1),
  },
  publishDialogList: {
    margin: 0,
    paddingLeft: theme.spacing(2),
    '& li': {
      fontSize: 13,
      color: '#333333',
      marginBottom: theme.spacing(0.5),
      '&:last-child': {
        marginBottom: 0,
      },
    },
  },
  publishDialogActions: {
    padding: theme.spacing(2, 3),
  },
  publishDialogCancelButton: {
    color: '#6A6A6A',
    fontWeight: 600,
    fontSize: 13,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
  },
  publishDialogConfirmButton: {
    backgroundColor: '#00234B',
    color: '#FFFFFF',
    fontWeight: 600,
    fontSize: 13,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
    padding: theme.spacing(1, 2.5),
    '&:hover': {
      backgroundColor: '#001834',
    },
    '&:disabled': {
      backgroundColor: '#9E9E9E',
      color: '#FFFFFF',
    },
  },
  // Delete dialog styles
  deleteDialogTitle: {
    '& .MuiDialogTitle-root, & h2': {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1.5),
    },
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    color: '#D32F2F',
    fontWeight: 600,
    padding: theme.spacing(2, 3),
  },
  deleteDialogIcon: {
    color: '#D32F2F',
    fontSize: 24,
    flexShrink: 0,
  },
  deleteDialogText: {
    fontSize: 14,
    color: '#333333',
    lineHeight: 1.6,
    marginBottom: theme.spacing(2),
  },
  deleteDialogWarning: {
    backgroundColor: '#FFF5F5',
    border: '1px solid #FFCDD2',
    borderRadius: 4,
    padding: theme.spacing(2),
  },
  deleteDialogWarningTitle: {
    fontSize: 13,
    fontWeight: 600,
    color: '#D32F2F',
    marginBottom: theme.spacing(1),
  },
  deleteDialogList: {
    margin: 0,
    paddingLeft: theme.spacing(2),
    '& li': {
      fontSize: 13,
      color: '#B71C1C',
      marginBottom: theme.spacing(0.5),
      '&:last-child': {
        marginBottom: 0,
      },
    },
  },
  deleteDialogActions: {
    padding: theme.spacing(2, 3),
  },
  deleteDialogCancelButton: {
    color: '#6A6A6A',
    fontWeight: 600,
    fontSize: 13,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
  },
  deleteDialogConfirmButton: {
    backgroundColor: '#D32F2F',
    color: '#FFFFFF',
    fontWeight: 600,
    fontSize: 13,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
    padding: theme.spacing(1, 2.5),
    '&:hover': {
      backgroundColor: '#B71C1C',
    },
    '&:disabled': {
      backgroundColor: '#9E9E9E',
      color: '#FFFFFF',
    },
  },
  // Sharing section styles
  sharingSection: {
    backgroundColor: '#F8FAFB',
    borderRadius: 8,
    border: '1px solid #D6E4F0',
    overflow: 'hidden',
    boxShadow: '0 2px 8px rgba(0, 48, 135, 0.08)',
  },
  shareDescription: {
    fontSize: 14,
    color: '#6A6A6A',
    marginBottom: theme.spacing(3),
  },
  shareButtonsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
    },
  },
  shareButton: {
    backgroundColor: '#FFFFFF',
    color: '#00234B',
    border: '2px solid #E0E0E0',
    fontWeight: 600,
    fontSize: 13,
    textTransform: 'none',
    padding: theme.spacing(1.5, 2),
    borderRadius: 8,
    justifyContent: 'flex-start',
    '&:hover': {
      backgroundColor: '#F5F5F5',
      borderColor: '#00234B',
    },
  },
  shareLinkContainer: {
    marginTop: theme.spacing(3),
    paddingTop: theme.spacing(3),
    borderTop: '1px solid #E0E0E0',
  },
  shareLinkLabel: {
    fontSize: 13,
    fontWeight: 600,
    color: '#00234B',
    marginBottom: theme.spacing(1.5),
  },
  shareLinkBox: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    backgroundColor: '#F5F5F5',
    borderRadius: 8,
    padding: theme.spacing(1.5),
    border: '1px solid #E0E0E0',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'stretch',
    },
  },
  shareLinkUrl: {
    flex: 1,
    fontSize: 13,
    color: '#00234B',
    fontFamily: 'monospace',
    wordBreak: 'break-all',
  },
  copyLinkButton: {
    backgroundColor: '#003087',
    color: '#FFFFFF',
    fontWeight: 600,
    fontSize: 12,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
    padding: theme.spacing(1, 2),
    borderRadius: 6,
    whiteSpace: 'nowrap',
    '&:hover': {
      backgroundColor: '#00234B',
    },
  },
}))

export default useStyles
